import React from 'react'
import { Outlet } from 'react-router-dom'

const RoomsPage = () => {
  return (
    <main>
      <Outlet/>
    </main>
  )
}

export default RoomsPage